//import $ from 'jquery';
//Datalayer and GTM Scripts
 function dataLayerCTA(action, label){
    window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
           'event': 'ctaClicks',                    
           'ga_event': {
               'category': 'Internal CTA Clicks',                     
               'action': action,                     
               'label': label,              
               'value': 0,
               'nonInteraction': 0
           }
   }); 
}

function socialDataLayerCTA(action, label){
    window.dataLayer = window.dataLayer || [];
       window.dataLayer.push({
           'event': 'socialClicks',                    
           'ga_event': {
               'category': 'Social Link',                     
               'action': action,                     
               'label': label,              
               'value': 0,
               'nonInteraction': 0
           }
    }); 
}

function extRetailerClicks(action, label){
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
     'event': 'extRetailerClicks',                    
     'ga_event': {
       'category': 'External Retailer Links',                     
       'action': action,                     
       'label': label,          
       'value': 0,
       'nonInteraction': 0
     }
    });
}

$(document).ready(function() {
    
    //home cta
     $('#home_banner .paragraph_link').click(function(){
        dataLayerCTA($('#home_banner .paragraph_title .title').text(), $(this).text());
    });
    
     $('#hero_center .content .link').click(function(){
        dataLayerCTA($('#hero_center .content .emphasize_title').text().trim().replace(/[\t\n]+/g,' ') + " " + $('#hero_center .content .bold_content').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    });
    
    // $('#for_any_occasion .collection-content-container .cta--link').click(function(){
        // dataLayerCTA($(this).siblings('a').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    // });
    
    $('.slider-bottom-link a').click(function(){
        dataLayerCTA($(this).text(), $(this).text());
    });
    
    $('#paragraph__hero_centralized_content__746 a').click(function(){
        dataLayerCTA($('#paragraph__hero_centralized_content__746 .content .top_title').text(), $(this).text());
    });
    
    
    //distillery page
    $('.distillery-hero .content p a').click(function(){
        dataLayerCTA($('.distillery-hero .content h1').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    });
    
    //distillery page
    $('.distillery-times a').click(function(){
        dataLayerCTA($('.welcome-orchard-title .welcome-orchard-title').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    });
    
    
    
    
    $('#hero_content .link').click(function(){
        dataLayerCTA($('#hero_content .top_title').text(), $(this).text());
    });
    
    // $('#hero_center .link').click(function(){
        // dataLayerCTA($('#hero_center .top_title').text(), $(this).text());
    // });
    
    $('#right_teaser .link').click(function(){
        dataLayerCTA($('#right_teaser .teaser_item_content').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    });
    
    // $('#highlight_slider .cta--link').click(function(){
    //   dataLayerCTA($(this).siblings('h3').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    // });
    
    $('#highlight_slider .desktop_link').click(function(){
       dataLayerCTA($('#highlight_slider .highlight_container .highlight_title').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    });
  
    
    //All Product Page - pending for now, waiting for final merge
    $('.list-counter').each(function(index){
        $(this).click(function(){
            dataLayerCTA($('.list-counter ._collection-whisky-listing h4').eq(index).text().trim().replace(/[\t\n]+/g,' '), $('.list-counter ._collection-whisky-listing .uppercase a.font-formulacondensed').eq(index).text());
        })
    });
    //Product Page Slider at bottom
    $('.where-next .slick-slide').each(function(index){
        $(this).click(function(){
            dataLayerCTA($('.where-next .slick-slide .collection-slide .collection-content-container a h3').eq(index).text().trim().replace(/[\t\n]+/g,' '), $('.where-next .slick-slide .collection-slide .collection-content-container .cta--link a').eq(index).text());
        })
    });
    
    //buy link
     $('.buy-link a').click(function(){
        extRetailerClicks($('.buy-title p span').text(), $(this).text());
    });
    
    
    //Social Footer
    $('.social--field-column a').click(function(){
       socialDataLayerCTA($(this).text(), $(this).text());
    }); 

    //speyside 
    $('#paragraph__hero_centralized_content__689 .content a').click(function(){
        dataLayerCTA($('#paragraph__hero_centralized_content__689 .top_title').text(), $(this).text());
    });
    
    //Orchard
    $('#paragraph__hero_centralized_content__784 .popup-youtube').click(function(){
        dataLayerCTA($('#paragraph__hero_centralized_content__784 .top_title').text() + " " + $('#paragraph__hero_centralized_content__784 .content h1').text().trim().replace(/[\t\n]+/g,' '), $(this).text());
    });
    
    $('#paragraph__hero_centralized_content__794 .popup-youtube').click(function(){
        dataLayerCTA($('#paragraph__hero_centralized_content__794 .top_title').text(), $(this).text());
    });
    
    $('#paragraph__hero_centralized_content__797 .popup-youtube').click(function(){
        dataLayerCTA($('#paragraph__hero_centralized_content__797 .top_title').text(), $(this).text());
    });
    
    $('#paragraph__hero_centralized_content__799 .popup-youtube').click(function(){
        dataLayerCTA($('#paragraph__hero_centralized_content__799 .top_title').text(), $(this).text());
    });
    
    $('#paragraph__double_panel_content__800 a.ext').click(function(){
        extRetailerClicks($('#paragraph__double_panel_content__800 .paragraph_content h2').text(), $(this).text());
    });
    
    // TCM DataLayer implementation 
    // event delegatiog to tcm-cta (used for Js with html appended to the dom - used on tours)
    // added #cboxWrapper to stop event duplicating with the standard click event.
    $('body #cboxWrapper').on('click','.tcm-cta',function(){
        handleTcmDataLayerEvent($(this));
    });
    
    // Standard click event
     $('.tcm-cta').on('click',function(){
        handleTcmDataLayerEvent($(this));
    });
    
    function handleTcmDataLayerEvent(e) {
        let action = e.data('cta-action');
        let label  = e.data('cta-label');
        let event  = e.data('cta-event');
        
        switch (event) {
            case 'ctaClicks':
                dataLayerCTA(action,label);
                break;
            case 'extRetailerClicks':
                extRetailerClicks(action,label);
                break;
            case 'socialClicks':
                socialDataLayerCTA(action,label);
                break;
            default:
                // no matching cta event do nothing
        }
    }
});
